import React from 'react';

import { TrendingIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import { InfoSection } from '../components/InfoSection';
import { StaticSupportCards } from '../components/StaticSupportCards';

export const VoiceHeardSection: React.FC<Props> = ({ className }) => {
	const { translate, localizeNumber } = useI18n();

	return (
		<InfoSection
			className={className}
			icon={
				<TrendingIcon
					size="medium"
					aria-label={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.voices_heard_alt')}
				/>
			}
			title={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.title')}
			subtitle={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.subtitle')}
			badge={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.signatures_badge', {
				count: localizeNumber(500000),
			})}
		>
			<StaticSupportCards />
		</InfoSection>
	);
};

type Props = {
	className?: string;
};
